import { listForms, createForm, duplicateForm, renameForm, getForm, setEligibleProjects, setFrequencies, setAmountPresets, setMessages, setCampaign, updateBranding, updateSettings, uploadVisual, publishForm, pauseForm, resumeForm, archiveForm, listVersions, getVersion, getFormDashboard, } from "../api/collecteApi";
export async function fetchForms(params) {
    return listForms(params);
}
export async function saveForm(body) {
    return createForm(body);
}
export async function duplicateFormAdapter(id, body) {
    return duplicateForm(id, body);
}
export async function renameFormAdapter(id, title) {
    return renameForm(id, title);
}
export async function fetchForm(id) {
    return getForm(id);
}
export async function saveEligibleProjects(id, projects) {
    return setEligibleProjects(id, projects);
}
export async function saveFrequencies(id, frequencies) {
    return setFrequencies(id, frequencies);
}
export async function saveAmountPresets(id, presets) {
    return setAmountPresets(id, presets);
}
export async function saveMessages(id, messages) {
    return setMessages(id, messages);
}
export async function saveBranding(id, branding) {
    return updateBranding(id, branding);
}
export async function saveCampaign(id, campaignId) {
    return setCampaign(id, campaignId);
}
export async function saveSettings(id, settings) {
    return updateSettings(id, settings);
}
export async function uploadFormVisual(id, file) {
    return uploadVisual(id, file);
}
export async function publishFormAdapter(id) {
    return publishForm(id);
}
export async function pauseFormAdapter(id) {
    return pauseForm(id);
}
export async function resumeFormAdapter(id) {
    return resumeForm(id);
}
export async function archiveFormAdapter(id, redirectToFormId) {
    return archiveForm(id, redirectToFormId);
}
export async function listFormVersions(id, params) {
    return listVersions(id, params);
}
export async function fetchFormVersion(id, versionNumber) {
    return getVersion(id, versionNumber);
}
export async function fetchFormDashboard(id) {
    return getFormDashboard(id);
}
